import { Box, Button, Menu, Typography } from '@mui/material';
import styled from 'styled-components';
import pallet from '../../../layouts/pallet';
import theme from '../../../layouts/theme';
import { fontSizes } from '../../../layouts/fontSizes';
import { PageWrapper } from '../../common/styled';

export const SearchContainer = styled(Box)(() => ({
  display: 'flex',
  gap: 16,
  alignItems: 'center',
  flexWrap: 'wrap'
  // '@media (max-width:586px)': {
  //   gap: 16,
  //   alignItems: 'start',
  //   flexDirection: 'column'
  // }
}));

export const SectionTitle = styled(Typography).attrs({
  variant: 'h5',
  as: 'h2'
})(() => ({
  fontWeight: 'bold',
  fontSize: `${fontSizes.sectionTitle} !important`,
  textWrap: 'nowrap'
}));

export const EditButton = styled(Button)(() => ({
  width: '100%',
  background: '#fff',
  border: '1px solid #D0D5DD',
  borderRadius: 8,
  color: '#344054',
  fontWeight: 500,
  fontSize: 14,
  textTransform: 'none',
  boxShadow: 'none',
  padding: '6px 0'
}));

export const ProfileImageBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 8,
  maxWidth: '170px'
}));

export const ImagePreview = styled('img')(() => ({
  maxWidth: 140,
  maxHeight: 140,
  borderRadius: 8,
  objectFit: 'cover'
}));

export const UploadButton = styled(Button)(() => ({
  border: `1px solid ${pallet.primary} !important`,
  color: pallet.primary,
  borderRadius: '8px !important',
  textTransform: 'none',
  fontWeight: 500,
  textWrap: 'nowrap',
  padding: '6px, 12px',
  background: 'transparent',
  '&:hover': {
    background: pallet.selectedBackground,
    borderColor: pallet.primaryHover
  }
}));

export const HelperText = styled(Typography).attrs({
  as: 'h5',
  variant: 'h5'
})(() => ({
  fontSize: 12,
  fontWeight: 400,
  marginTop: 0,
  width: 'fit-content',
  color: pallet.lightBlueText,
  marginBottom: 8
}));

export const ActiveContainer = styled(Box)<{
  backgroundColor?: string;
  color?: string;
}>(({ backgroundColor, color }) => ({
  backgroundColor: backgroundColor || pallet.lightGreen,
  color: color || pallet.green2,
  paddingInline: 12,
  paddingBlock: 4,
  borderRadius: 4,
  fontWeight: 500,
  fontSize: fontSizes.subtitle
}));

export const HeaderWrapper = styled(Box)(() => ({
  display: 'flex',
  gap: '16px',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'space-between',

  '@media (min-width:600px)': {
    gap: '24px'
  },
  '@media (min-width:900px)': {
    gap: '32px'
  }
}));

export const LeftContent = styled(Box)(() => ({
  display: 'flex',
  gap: '16px',
  alignItems: 'center',
  flexWrap: 'wrap'
}));

export const TabButtonWrapper = styled(Box)(() => ({
  display: 'flex',
  gap: '16px',
  overflow: 'auto',
  height: '42px'
}));

export const StudentProfileWrapper = styled(Box)(() => ({
  marginTop: '16px',
  display: 'flex',
  gap: 16,
  flexDirection: 'column',
  alignItems: 'center',
  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
    alignItems: 'flex-start'
  }
}));

export const ActionsMenu = styled(Menu)(() => ({
  '& .MuiPaper-root': {
    marginTop: 8,
    borderRadius: 16,
    border: '1px solid #E5E7EB',
    overflow: 'hidden',
    minWidth: 220,
    boxShadow: 'none'
  }
}));

export const SiblingStatusWrapper = styled(Box)<{
  backgroundColor: string;
  color: string;
}>(({ backgroundColor, color }) => ({
  width: '100%',
  minWidth: '80px',
  height: '30px',
  borderRadius: '4px',
  fontSize: '0.95rem',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginTop: '10px',
  backgroundColor: backgroundColor,
  color: color,
  padding: '12px 12px'
}));

export const TitleBorderWrapper = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '10px'
}));

export const RoundedButton = styled(Button).attrs({
  variant: 'contained',
  color: 'primary'
})({
  borderRadius: '8px !important'
});

export const RoundedSearchButton = styled(Button).attrs({
  variant: 'contained',
  color: 'primary'
})({
  borderRadius: '8px !important',
  marginTop: '0px !important',
  width: '100%',
  '@media (min-width:600px)': {
    width: 'auto'
  }
});

export const SaveActionButtonWrapper = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between'
}));

export const RenderTabContentBox = styled(Box)(() => ({
  height: 'inherit',
  overflow: 'auto'
}));

export const RenderTabContentWrapper = styled(PageWrapper)(() => ({
  padding: '16px',
  minHeight: 'auto',
  display: 'flex',
  flexDirection: 'column',
  gap: '48px'
}));

export const StatusCircularDot = styled(Box)<{ circleColor: string }>(
  ({ circleColor }) => ({
    width: '6px',
    minWidth: '6px',
    height: '6px',
    borderRadius: '50%',
    backgroundColor: circleColor,
    marginRight: '8px'
  })
);

export const GenerateLcFormWrapper = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 8
}));

export const ButtonContainer = styled(Box)({
  display: 'flex',
  alignItems: 'flex-end',
  gap: '16px',
  justifyContent: 'flex-end',
  width: '100%'
});